import Logo from '@/images/logo.svg?react';
import LogoIcon from '@/images/logo-icon.svg?react';
import LogoInverse from '@/images/logo-inverse.svg?react';
import { THEME } from '@enmon/commons';

const theme = {
  /**
   * New future v2 theme available at https://www.figma.com/file/puBxCo7vOePFN6Tjr191kB/%E2%9D%96-Enmon-component-library
   */
  v2: {
    color: {
      weather: {
        five: '#61808B',
      },
    },
  },
  color: THEME.color,

  /**  @deprecated  Use `color` instead. */
  colors: {
    // THEME GENERATOR START https://developer.microsoft.com/en-us/fabric#/styles/themegenerator
    themeLighterAlt: '#f3fbfb',
    themeLighter: '#d0f0ef',
    themeLight: '#abe3e1',
    themeTertiary: '#64c8c3',
    themeSecondary: '#2faea8',
    themePrimary: '#1BA39C',
    themeDarkAlt: '#19938d',
    themeDark: '#157c77',
    themeDarker: '#105b58',

    themeAccentPrimary: '#FF7F48',
    themeAccentSecondary: '#FF986C',

    themeWarning: '#FFAC32',
    themeError: '#F55B5D',

    white: '#ffffff',
    neutralLighterAlt: '#fbfbfb',
    neutralLighter: '#f4f4f4',
    neutralLight: '#eaeaea',
    neutralSecondaryAlt: '#c8c8c8',
    neutralSecondaryLight: '#888',
    neutralSecondary: '#595959',
    neutralPrimaryAlt: '#2f2f2f',
    neutralPrimary: '#0b0b0b',
    neutralDark: '#151515',
    // THEME GENERATOR END

    files: {
      pdf: '#A02315',
      xls: '#356A44',
      doc: '#0067B8',
      html: '#e44d26',
      txt: '#151515',
      zip: '#b89911',
    },
  },

  typography: THEME.typography,
  spacing: THEME.spacing,
  /** @deprecated Use 'typography' instead */
  font: THEME.font,
  /**  @deprecated  Use `typography` instead. */
  fonts: {
    heading: {
      family: 'Poppins, sans-serif' as const,
      weight: 500 as const,
    },
    body: {
      family: 'Poppins, sans-serif' as const,
      weight: 400 as const,
    },
  },
  Logo,
  LogoIcon,
  LogoInverse,
  breakpoints: {
    xxl: 1600,
    xl: 1200,
    lg: 992,
    md: 768,
    sm: 576,
  },
};

/**  @deprecated  Use `THEME.color.charts.palletes.meaning` from `@enmon-commons` instead. */
export const chartMeaningColor = {
  chartPrimary: '#00C33F',

  /** @deprecated Use `THEME.color.charts.palletes.common.primary.one` from `@enmon-commons` instead. */
  chartSecondary: THEME.color.charts.palletes.common.primary.one,

  /** @deprecated Use `THEME.color.charts.palletes.common.primary.two` from `@enmon-commons` instead. */
  chartTertiary: THEME.color.charts.palletes.common.primary.ten,

  /** @deprecated Use `THEME.color.status.info` from `@enmon-commons` instead. */
  chartAccent: THEME.color.status.info,

  /** @deprecated Use `THEME.color.charts.palletes.common.primary.six` from `@enmon-commons` instead. */
  chartWarning: THEME.color.charts.palletes.common.primary.six,

  /** @deprecated Use `THEME.color.status.error` from `@enmon-commons` instead. */
  chartErrorPrimary: THEME.color.status.error,

  /** @deprecated Use `THEME.color.charts.palletes.common.primary.eight` from `@enmon-commons` instead. */
  chartErrorSecondary: THEME.color.charts.palletes.common.primary.eight,
};

export const chartPaletteColors = [
  '#00F44F',
  '#FFAC32',
  '#00C8E8',
  '#5E7AF8',
  '#F55B5D',
  '#F55B9C',
  '#BA5BF5',
  '#2DFFB3',
  '#2CFFF2',
  '#B8F634',
];

export const { breakpoints } = theme;

export default theme;
